import React from 'react';

interface ImageViewerProps {
  fileUrl: string;
  fileName: string;
  zoom: number;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ fileUrl, fileName, zoom }) => {
  return (
    <div className="flex items-center justify-center min-h-[600px] bg-gray-50 rounded-lg">
      <img
        src={fileUrl}
        alt={fileName}
        className="max-w-full max-h-full object-contain rounded shadow-lg"
        style={{ transform: `scale(${zoom / 100})` }}
      />
    </div>
  );
};

export default ImageViewer;
